/**
 * 教材
 * 教材API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The AuditCreateForm model module.
   * @module textbook_v2/model/AuditCreateForm
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>AuditCreateForm</code>.
   * @alias module:textbook_v2/model/AuditCreateForm
   * @class
   */
  var exports = function() {
    var _this = this;




  };

  /**
   * Constructs a <code>AuditCreateForm</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:textbook_v2/model/AuditCreateForm} obj Optional instance to populate.
   * @return {module:textbook_v2/model/AuditCreateForm} The populated <code>AuditCreateForm</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'unitId')) {
        obj['unitId'] = ApiClient.convertToType(data['unitId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'summary')) {
        obj['summary'] = ApiClient.convertToType(data['summary'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'fileList')) {
        obj['fileList'] = ApiClient.convertToType(data['fileList'], ['String']);
      }
    }
    return obj;
  }

  /**
   * 单元id
   * @member {Integer} unitId
   */
  exports.prototype['unitId'] = undefined;
  /**
   * 提交说明
   * @member {String} summary
   */
  exports.prototype['summary'] = undefined;
  /**
   * 附件
   * @member {Array.<String>} fileList
   */
  exports.prototype['fileList'] = undefined;



  export default exports;
;


